import { mountApp } from './setup.js';

mountApp();
